import { AlertCircle, CheckCircle, Info } from 'react-feather'

interface StaticAlertProps {
  heading: string
  type: 'SUCCESS' | 'INFO' | 'ERROR'
  description?: string
  isCancellable?: boolean
  customClass?: string
  headingClass?: string
}

const StaticAlert: React.FC<StaticAlertProps> = ({
  heading,
  description,
  type,
  isCancellable,
  customClass,
  headingClass = 'text-sm'
}) => {
  const getIcon = () => {
    switch (type) {
      case 'ERROR':
        return <AlertCircle className='w-4 h-4' />
      case 'SUCCESS':
        return <CheckCircle className='w-4 h-4' />
      case 'INFO':
        return <Info className='w-4 h-4' />
    }
  }

  const getStyle = () => {
    switch (type) {
      case 'ERROR':
        return 'border-red-dark text-red-dark'
      case 'SUCCESS':
        return 'border-green-dark text-green-dark'
      case 'INFO':
        return `bg-gray-lightest border-coal-lighter text-coal-dark ${customClass}`
    }
  }
  return (
    <div className={`flex flex-row relative w-full p-3 border-1 rounded-lg ${getStyle()}`}>
      <div className='flex flex-row gap-2 items-center'>
        {getIcon()}
        <p className={headingClass}>{heading}</p>
      </div>
    </div>
  )
}
export default StaticAlert
